import { Component, Inject, OnInit } from '@angular/core';

import { map } from 'rxjs/internal/operators/map';

import { LessonStatus, School, LessonPagination } from '@df/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { PrivilegeService } from '@app/core/services/privilege.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteFormComponent } from '@app/teacher/components/prepare/delete-form/delete-form.component';
import { catchError, mergeMap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';

@Component({
    selector: 'app-edit-lesson-modal',
    templateUrl: './edit-lesson-modal.component.html',
    styleUrls: ['./edit-lesson-modal.component.scss']
})
export class EditLessonModalComponent implements OnInit {
    lesson: LessonPagination;

    public school: School = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: any,
        private snackBar: MatSnackBar,
        private dialogRef: MatDialogRef<DeleteFormComponent>,
        private teacherService: TeacherService,
        private prvService: PrivilegeService
    ) {}

    ngOnInit() {
        this.lesson = this.data.lesson;

        this.prvService
            .getSchools()
            .pipe(
                map(schools => {
                    for (const school of schools.results) {
                        if (
                            this.lesson &&
                            this.lesson.student_class &&
                            this.lesson.student_class.school.id === school.id
                        ) {
                            return school;
                        }
                    }
                })
            )
            .subscribe(school => {
                this.school = school;
            });
    }

    public closeModal(data: any = null): void {
        this.dialogRef.close(data);
    }

    public changeLessonStatusInWork(): void {
        this.teacherService
            .updateLessons(String(this.lesson.id), { status: LessonStatus.LESSON_IN_WORK })
            .pipe(
                mergeMap(next => {
                    if (!next) {
                        return throwError(null);
                    }
                    return of(next);
                }),
                catchError(err => {
                    this.snackBar.open('Ошибка при изменении урока', 'Ok', {
                        duration: 2000
                    });
                    return throwError(err);
                })
            )
            .subscribe(next => {
                this.closeModal(next);
            });
    }
}
